<template>
    <!-- footer -->
    <footer class="mt-16">

        <el-row :gutter="0" class="orc-vert-limit-content pb-12 orc-wave-padding">

            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="pr-12 py-0">
                <span class="text-white">Orca</span>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="pb-16 orc-wave-padding">
                <el-row :gutter="30">
                    <el-col :span="12">
                        <h2 class="mb-2">Takken</h2>

                        <ul>
                            <li v-for="branch in nonPseudoBranches" v-bind:key="branch.id">
                                <el-link type="info" :underline="false" @click="changeBranch(branch.id)"> {{branch.label}}</el-link>
                            </li>
                        </ul>
                    </el-col>

                    <el-col :span="12">
                        <h2 class="mb-2">Club</h2>

                        <ul>
                            <li>
                                <el-link type="info" :underline="false"><a href="#questions">FAQ</a></el-link></el-link>
                            </li>
                            <li>
                                <el-link type="info" :underline="false"><a href="#news">Nieuws</a></el-link>
                            </li>
                            <li>
                                <el-link type="info" :underline="false"><a href="#agenda">Agenda</a></el-link>
                            </li>
                            <li>
                                <el-link type="info" :underline="false"><a href="#contact">Contacteer ons</a></el-link>
                            </li>
                            <li>
                                <router-link :to="{ path: 'privacy'}"><el-link type="info" :underline="false">Privacy</el-link></router-link>
                            </li>
                            <li>
                                <router-link :to="{ path: 'terms'}"><el-link type="info" :underline="false">Intern reglement</el-link></router-link>
                            </li>
                            <li>
                                <router-link :to="{ path: 'conduct'}"><el-link type="info" :underline="false">Gedragscode</el-link></router-link>
                            </li>
                            <li>
                                <router-link :to="{ path: 'code'}"><el-link type="info" :underline="false">Panathlonverklaring</el-link></router-link>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>

        <div class="footer-bottom pb-24">

            <div class="footer-deco absolute left-0 bottom-0 right-0 top-0"></div>

            <div class="absolute left-0 bottom-0 right-0">
                <div class="orc-vert-limit-header flex justify-between">
                    <div class="uppercase text-xs text-white pb-6 orc-brand">
                        <span class="orc-opc">Website by</span> Laurens Vijnck
                    </div>
                    <div class="flex mb-5">
                        <a class="social-badge mr-2" href="https://www.instagram.com/orcabilzen/">
                            <img src="../../../assets/instagram-brands.svg" width="20" height="20" class="text-white"/>
                        </a>

                        <a class="social-badge" href="https://www.facebook.com/OrcaBilzen/">
                            <img src="../../../assets/facebook-f-brands.svg" width="15" height="15"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "OrcaFooter",
        props: ['branchId', 'branchOptions'],
        methods: {
            changeBranch(branchId) {
                this.$parent.changeBranch(branchId)
            }
        },
        computed: {
            nonPseudoBranches() {
                if (this.branchOptions) {
                    return this.branchOptions.filter(e => {
                        return !e.pseudo
                    })
                } else {
                    return []
                }
            }
        }
    }
</script>

<style scoped>
    .footer-bottom {
        background-color: #00a5ff;
        color: #737688;
        position: relative;
        margin-top: 150px;
        line-height: 40px;
    }

    .footer-deco:before {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        background: url('../../../assets/orca-blue-2.svg') no-repeat;
        background-position: center bottom;
        background-size: 120%;
        margin-bottom: 80px;
        left: 0;
        right: 0;
        height: 200px;
    }

    @media only screen and (max-width: 600px) {
        .footer-deco:before, .orc-brand {
            display: none;
        }

        .orc-wave-padding {
          padding-bottom: 0px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/footer/OrcaFooter.vue